import React from 'react'

const FleetsLanding = () => {
  return (
    <>
      <div className="card">
        <div className="card-header">
          Patient Medication Requests
        </div>
        <div className="card-body">
          <code className="highlighter-red">Please scan the QR code on the App to start.</code>
        </div>
      </div>
    </>
  )
}

export default FleetsLanding
